import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (!process.env.REACT_APP_GA_MEASUREMENT_ID) {
            return;
        }

        if (!(window as any)._gaInitialized) {
            return;
        }

        ReactGA.send({ hitType: "pageview", page: location.pathname });
        console.log("Page tracked:", location.pathname);
    }, [location]);
}
